import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary:   { main: '#FF5B3A', dark: '#D94828', light: '#FFF0ED', contrastText: '#fff' },
    secondary: { main: '#0F1B35', dark: '#060e1e', light: '#162240', contrastText: '#fff' },
    success:   { main: '#1D9E75', light: '#E1F5EE' },
    warning:   { main: '#EF9F27', light: '#FAEEDA' },
    error:     { main: '#E24B4A', light: '#FCEBEB' },
    info:      { main: '#378ADD', light: '#E6F1FB' },
    background:{ default: '#F4F4F0', paper: '#FFFFFF' },
    text:      { primary: '#111111', secondary: '#666666', disabled: '#AAAAAA' },
    divider:   '#E8E8E4',
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
    h1: { fontFamily: "'Poppins', sans-serif", fontWeight: 800 },
    h2: { fontFamily: "'Poppins', sans-serif", fontWeight: 800 },
    h3: { fontFamily: "'Poppins', sans-serif", fontWeight: 700 },
    h4: { fontFamily: "'Poppins', sans-serif", fontWeight: 700 },
    h5: { fontFamily: "'Poppins', sans-serif", fontWeight: 700 },
    h6: { fontFamily: "'Poppins', sans-serif", fontWeight: 700 },
    subtitle1: { fontFamily: "'Poppins', sans-serif", fontWeight: 500 },
    body1:     { fontFamily: "'Poppins', sans-serif", fontSize: 14 },
    body2:     { fontFamily: "'Poppins', sans-serif", fontSize: 13 },
    caption:   { fontFamily: "'Poppins', sans-serif", fontSize: 11 },
    button:    { fontFamily: "'Poppins', sans-serif", fontWeight: 500, textTransform: 'none' },
  },
  shape: { borderRadius: 12 },
  shadows: [
    'none',
    '0 1px 4px rgba(0,0,0,0.06)',
    '0 2px 8px rgba(0,0,0,0.08)',
    '0 4px 16px rgba(0,0,0,0.10)',
    '0 8px 24px rgba(0,0,0,0.12)',
    ...Array(20).fill('none'),
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 50, padding: '8px 20px', fontSize: 13 },
        containedPrimary: { boxShadow: '0 4px 14px rgba(255,91,58,0.3)', '&:hover': { boxShadow: '0 6px 20px rgba(255,91,58,0.4)' } },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 14, border: '0.5px solid #E8E8E4', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            fontSize: 13,
            '&:hover fieldset': { borderColor: '#FF5B3A' },
            '&.Mui-focused fieldset': { borderColor: '#FF5B3A', borderWidth: 1.5 },
          },
          '& label.Mui-focused': { color: '#FF5B3A' },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: { borderRadius: 10, fontSize: 13 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 50, fontFamily: "'Poppins', sans-serif", fontSize: 11, fontWeight: 500 },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: '#F9F9F7',
            color: '#AAAAAA',
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { borderColor: '#E8E8E4', fontSize: 13 },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: { borderRadius: 50, height: 7, backgroundColor: '#F0F0EC' },
        bar:  { borderRadius: 50 },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: { background: '#0F1B35', border: 'none' },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          margin: '2px 8px',
          color: 'rgba(255,255,255,0.5)',
          '&:hover': { backgroundColor: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.85)' },
          '&.Mui-selected': { backgroundColor: 'rgba(255,91,58,0.18)', color: '#fff', '&:hover': { backgroundColor: 'rgba(255,91,58,0.24)' } },
        },
      },
    },
    MuiRating: {
      styleOverrides: {
        iconFilled:  { color: '#F5A623' },
        iconEmpty:   { color: '#E0E0E0' },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: 10 },
      },
    },
  },
});

export default theme;